import { render } from "./PorkDataForm.vue?vue&type=template&id=4a2f46e4&scoped=true&ts=true"
import script from "./PorkDataForm.vue?vue&type=script&lang=ts"
export * from "./PorkDataForm.vue?vue&type=script&lang=ts"

import "./PorkDataForm.vue?vue&type=style&index=0&id=4a2f46e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2f46e4"]])

export default __exports__